
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sadhguru",
      function () {
        return require("private-next-pages/[region]/sadhguru/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sadhguru"])
      });
    }
  